import {Hex, getAddress} from 'viem';

export const getShortAccountAddress = (account: string, edgeCharLength = 4) => {
  const startChars = account.slice(0, edgeCharLength);
  const endChars = account.slice(account.length - edgeCharLength);
  return `${startChars}...${endChars}`;
};

export const getIsAddressValid = (address: string): address is Hex => {
  try {
    return !!getAddress(address);
  } catch {
    return false;
  }
};

export const accountDisplayToAvatarUrl = (address: string): string =>
  `/assets/avatars/${(address.replace(/^0[x,X]|\d+|\.+/g, '')[0] ?? 'a').toLowerCase()}.png`;
